var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLogin && _vm.showCouponBtn)?_c('div',{staticClass:"header-coupon-btn",class:{
    'no-faq-btn': _vm.noFaqBtn,
    'has-pay-assistant': _vm.isPayAssistantEnabled
  },on:{"click":_vm.handleCouponButtonClick}},[_c('div',{staticClass:"header-coupon-btn-ico",style:(_vm.couponIconStyle)}),(_vm.showRedDot)?_c('em',{staticClass:"red-dot"}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }